function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 32H3C1.34667 32 0 30.6547 0 29V15C0 13.3453 1.34667 12 3 12H21C22.6533 12 24 13.3453 24 15V29C24 30.6547 22.6533 32 21 32ZM3 14C2.44933 14 2 14.448 2 15V29C2 29.552 2.44933 30 3 30H21C21.5507 30 22 29.552 22 29V15C22 14.448 21.5507 14 21 14H3Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19 14C18.448 14 18 13.552 18 13V8C18 4.692 15.308 2 12 2C8.692 2 6 4.692 6 8V13C6 13.552 5.552 14 5 14C4.448 14 4 13.552 4 13V8C4 3.588 7.588 0 12 0C16.412 0 20 3.588 20 8V13C20 13.552 19.552 14 19 14Z",
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 22.6667C10.5293 22.6667 9.33325 21.4707 9.33325 20C9.33325 18.5294 10.5293 17.3334 11.9999 17.3334C13.4706 17.3334 14.6666 18.5294 14.6666 20C14.6666 21.4707 13.4706 22.6667 11.9999 22.6667ZM11.9999 19.3334C11.6333 19.3334 11.3333 19.632 11.3333 20C11.3333 20.368 11.6333 20.6667 11.9999 20.6667C12.3666 20.6667 12.6666 20.368 12.6666 20C12.6666 19.632 12.3666 19.3334 11.9999 19.3334Z",
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12 26.6667C11.448 26.6667 11 26.2187 11 25.6667V22C11 21.448 11.448 21 12 21C12.552 21 13 21.448 13 22V25.6667C13 26.2187 12.552 26.6667 12 26.6667Z",
  fill: "current"
});

function SvgPadlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/Padlock.66a7c6b7.svg";
export { ForwardRef as ReactComponent };